import { withLDProvider } from 'launchdarkly-react-client-sdk';

export const withFeatureFlagProvider = (WrappedComponent) => {
  if (FEATURE_FLAG_SOURCE === 'launch_darkly_local') {
    return withLDProvider({
      clientSideID: 'focus-account-wide',
      context: {
        kind: 'user',
        anonymous: true,
      },
      options: {
        sendEvents: false,
        baseUrl: LAUNCHDARKLY_LOCAL_URL,
        streamUrl: LAUNCHDARKLY_LOCAL_URL,
      },
      reactOptions: {
        useCamelCaseFlagKeys: false,
      },
    })(WrappedComponent);
  }

  if (FEATURE_FLAG_SOURCE === 'launch_darkly_remote') {
    return withLDProvider({
      clientSideID: LAUNCHDARKLY_CLIENT_SIDE_ID,
      context: {
        kind: 'user',
        anonymous: true,
      },
      options: {
        streaming: false,
        sendEvents: false,
      },
      reactOptions: {
        useCamelCaseFlagKeys: false,
      },
    })(WrappedComponent);
  }
};
